import React from 'react';
import glass from '../../images/mag-glass.png';
import gear from '../../images/settings.png';
import work from '../../images/working.jpg';
import verify from '../../images/verify.png';

export const VisitasSeguridad = ({infoCompany}) => {
    const seguridadData = infoCompany?.view_segurity || [];
    const images = [glass, gear, verify];

    return (
        <div>
            <div className="seguridad-container">
                <div className="header-area">
                    <div className="header-area">
                        <h1>Sistema de <span style={{color: 'var(--theme-visit)'}}>seguridad de</span> nuestro Producto</h1>
                    </div>
                </div>
                <div className="left-area" style={{ borderBottom:`10px solid var(--theme-visit)`, borderRight:`10px solid var(--theme-visit)` }}></div>
                <div className="right-area"></div>
                <div className="pill-container" style={{ border:`10px solid var(--theme-visit)` }}>
                    <div className="pill-interior">
                        <div className="pill-content">
                            <img src={work} className="pill-image" alt="" />
                        </div>
                    </div>
                </div>

                <div className="features">
                    {seguridadData.map((item, index) => (
                        <div className="feature-card" key={index}>
                            <div 
                                className={index === 0 ? "feature-icon-blue" : "feature-icon-white"}
                                style={index === 0 ? { background: 'var(--theme-visit)' } : {}}
                            >
                                <div className="icon-container-class" >
                                    <img
                                        src={images[index] || verify}
                                        className="image-verification"
                                        alt=""
                                    />
                                </div>
                            </div>
                            <h2 className="feature-title">{item.title}</h2>
                            <p className="feature-description">{item.text}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="mobile-seguridad-container">
                <h1 className="mobile-security-title">
                    Sistema de <span style={{color: 'var(--theme-visit)'}}>seguridad de</span> nuestro Producto
                </h1>

                <div className="mobile-security-cards">
                    {seguridadData.map((item, index) => (
                        <div className="mobile-security-card" key={index}>
                            <div className={"security-icon-circle"}>
                                <img
                                    src={images[index] || verify}
                                    alt="security"
                                    className="security-icon"
                                />
                            </div>
                            <div className="security-content">
                                <h3>{item.title}</h3>
                                <p>{item.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
